import firebase from 'firebase/app'

export default {
  namespaced: true,
  state: {
    uId: null
  },
  getters: {
    getUserId(state) {
      return state.uId;
    }
  },
  mutations: {
    setUid(state, payload) {
      state.uId = payload
    }
  },
  actions: {
    async Login({dispatch, commit}, {email, password}) {
      try {
        await firebase.auth().signInWithEmailAndPassword(email, password)
      } catch (e) {
        await commit('setError', e)
        throw e
      }
    },
    async addArticle({dispatch, commit}, {title, discription, text}) {
      try {
        await firebase.database().ref('database/stories').push({
          title: title,
          discription: discription,
          text: text
        })
        .then(function() {
          console.log("Document successfully written!");
        })
        .catch(function(error) {
          console.error("Error writing document: ", error);
        });
      } catch (e) {
        throw e
      }
    },
    getUid() {
      const user = firebase.auth().currentUser
      return user ? user.uid : null
    },
    async logout ({commit}) {
      await firebase.auth().signOut()
      commit('setUid', null)
    }
  }
}